import axios from './axios'

// 用户登录
export function login(data) {
  return axios({
    url: '/api/login',
    method: 'post',
    data
  })
}

// 用户注册
export function register(data) {
  return axios({
    url: '/api/register',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function sendSMS(data) {
  // 实际环境使用的代码（已注释）
  return axios({
    url: '/api/send-sms',
    method: 'post',
    data
  })
}

// 用户退出
export function logout() {
  return axios({
    url: '/api/logout',
    method: 'post'
  })
}

// 获取用户信息
export function getInfo() {
  return axios({
    url: '/api/user/info',
    method: 'get'
  })
}

// 微信用户绑定手机号
export function bindPhoneForWechatUser(data) {
  return axios({
    url: '/api/user/bind-phone',
    method: 'post',
    data
  })
}

// 微信登录
export function wechatLogin(data) {
  return axios({
    url: '/api/wechat/login',
    method: 'post',
    data
  })
}

// 绑定手机号
export function bindPhone(data) {
  return axios({
    url: '/api/wechat/bind-phone',
    method: 'post',
    data
  })
}
